
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/author/[userName]",
      function () {
        return require("private-next-pages/author/[userName]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/author/[userName]"])
      });
    }
  